import { locales, orderedLocaleCodes } from '@tablecheck/locales';

export const ROUTES = {
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  FAILED: 'failed',
  UNLOCK_ACCOUNT: 'unlock',
  SSO: 'sso'
};

export const API_ENDPOINTS = {
  SIGN_IN: '/sso/oauth/identity/callback',
  RESET_PASSWORD: '/api/passwords',
  PASSWORD_REQUIREMENTS: '/api/passwords/requirements',
  UNLOCK_ACCOUNT: '/api/unlocks',
  SSO_PROVIDERS: '/api/sso_providers',
  PASSKEY_CREATE_OPTIONS: '/api/passkeys/create_options',
  CREATE_PASSKEY: '/api/passkeys/create',
  PASSKEY_REQUEST_OPTIONS: '/api/passkeys/request_options',
  VERIFY_PASSKEY: '/api/passkeys/verify'
};

export const STATUS_PAGE_POLLING_INTERVAL = 60 * 1000; // 1 minute

export const BREAKPOINTS = {
  mobile: '428px',
  tablet: '853px',
  laptop: '1279px'
};

export const DELAYS = {
  exitAnimation: 700,
  loginCountdown: 5000
};

export const SUPPORTED_LOCALES = orderedLocaleCodes;
export const DEFAULT_LOCALE = locales.english.code;
export const STORAGE_KEY_SSO_PROVIDER = 'heimdall/sso-provider';
export const STORAGE_KEY_PASSKEY_LOGIN = 'heimdall/passkey-login';
